<ui-modal-offcanvas-trigger
  id="offcanvas_minicart-trigger"
  targetId="offcanvas_minicart"
  class="btn btn-icon position-relative"
  role="button"
  tabindex="0"
  data-testid="header-minicart-trigger"
  data-gtmaction="event_preview_cart"
  data-gtmcategory="event_bin_action"
  [ngClass]="{ not_empty: (cartCount$ | async)! > 0 }"
  (click)="open(); gtmEvent($event)"
  (keyup)="open(); gtmEvent($event)"
>
  <img class="shopping-bag-icon" alt="Shopping bag" [src]="'assets/images/icons/bag.svg' | staticFileHash" />
  <span class="header-minicart-number" [ngClass]="{ 'd-none': (cartCount$ | async)! === 0 }">
    {{ cartCount$ | async }}
  </span>
  <span class="sr-only" i18n="@@YOUR_CART">Your cart</span>
</ui-modal-offcanvas-trigger>

<div
  tabindex="0"
  id="modalBackdrop"
  class="modal-backdrop"
  (click)="close('offcanvas_minicart')"
  (keyup)="close('offcanvas_minicart')"
></div>

<div title="Minicart">
  <div #minicart class="offcanvas offcanvas-end" tabindex="-1" id="offcanvas_minicart" data-testid="offcanvas-container">
    <div id="minicart_header" class="offcanvas-header">
      <button
        type="button"
        class="btn btn-text"
        data-bs-dismiss="offcanvas"
        data-testid="offcanvas-dismiss"
        (click)="close('offcanvas_minicart')"
      >
        <i class="fal fa-chevron-left"></i>
        <span i18n="@@CLOSE">Close</span>
      </button>
      <div class="btn btn-icon">
        <img class="shopping-bag-icon" alt="Shopping bag" [src]="'assets/images/icons/bag.svg' | staticFileHash" />
      </div>
    </div>
    <app-minicart
      [cartProductRemovalConfirmed]="productToRemove$.asObservable()"
      (showCartRemovalConfirmationModal)="openModal($event)"
    />
  </div>
</div>

<app-modal sourceId="offcanvas_confirm_remove_cart_product" [showTitle]="false" [keepBackDrop]="true">
  <app-remove-product-from-cart
    (closeRemoveProductModalEvent)="closeModal()"
    (cartProductRemovalConfirmationEvent)="removeCartProduct()"
  />
</app-modal>
